import React from 'react';
import { connect, useDispatch } from 'react-redux';
import { Button, Checkbox, Label, LabeledControl, Spacer, Text, TextButton } from '@zillow/constellation-10';
import { HR } from '@zg-rentals/zrs-comet';
import { UserPermissionsConstants } from '@zg-rentals/rental-manager-env';
import UserManagementActions from '../../redux/actions/UserManagementActions';
import { EVENT_IDS } from '../../modal/ClickstreamEvents';

export interface QuestionsType {
  onNextStep: () => void;
  onCancel: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  currentUser?: any;
  onBack?: () => void;
}

const Questions = ({ currentUser, onNextStep, onCancel, onBack }: QuestionsType) => {
  const dispatch = useDispatch();
  const allProperties = currentUser.permissions[UserPermissionsConstants.PERMISSIONS.SYNC_PROPERTIES];
  const hasProperties = currentUser.properties.length > 0;
  const [hasLimitedProperties, setHasLimitedProperties] = React.useState(!allProperties && hasProperties);

  const handleSetSyncProperties = () => {
    const newPermissions = {
      ...currentUser.permissions,
      [UserPermissionsConstants.PERMISSIONS.SYNC_PROPERTIES]: true,
    };
    dispatch(UserManagementActions.currentUserSetPermissions(newPermissions));
    setHasLimitedProperties(false);
  };

  const handleSetLimitedProperties = () => {
    const newPermissions = {
      ...currentUser.permissions,
      [UserPermissionsConstants.PERMISSIONS.SYNC_PROPERTIES]: false,
    };
    dispatch(UserManagementActions.currentUserSetPermissions(newPermissions));
    setHasLimitedProperties(true);
  };

  return (
    <div>
      <Spacer css={{ marginBlock: 'sm' }}>
        <Text>Grant Property Access</Text>
      </Spacer>
      <Spacer css={{ marginBlockEnd: 'sm' }}>
        <Text>
          {`Do you want ${currentUser.userName} to have access to all
                    properties or selected properties?`}
        </Text>
      </Spacer>
      <LabeledControl
        label={<Label>All properties - This will automatically include any properties added in the future</Label>}
        control={
          <Checkbox
            checked={currentUser.permissions[UserPermissionsConstants.PERMISSIONS.SYNC_PROPERTIES]}
            onChange={handleSetSyncProperties}
          />
        }
      />
      <LabeledControl
        label={
          <Label>
            Selected properties - You&apos;ll choose which properties
            {` ${currentUser.userName} `}
            can access. Access to future properties must be granted manually
          </Label>
        }
        control={<Checkbox checked={hasLimitedProperties} onChange={handleSetLimitedProperties} />}
      />
      <HR />
      <div className="Questions-footer">
        <TextButton className="Questions-button" onClick={onCancel} data-eventid={EVENT_IDS.CANCEL_ADDING_NEW_USER}>
          Cancel
        </TextButton>
        <div>
          <TextButton className="Questions-button" onClick={onBack}>
            Back
          </TextButton>
          <Button
            tone="brand"
            emphasis="filled"
            onClick={onNextStep}
            disabled={
              !(currentUser.permissions[UserPermissionsConstants.PERMISSIONS.SYNC_PROPERTIES] || hasLimitedProperties)
            }
          >
            Continue
          </Button>
        </div>
      </div>
    </div>
  );
};

// @ts-ignore
const mapStateToProps = (state) => ({
  currentUser: state.userManagement.currentUser,
});

// @ts-ignore
export default connect(mapStateToProps)(Questions);
